import { fromJS, Map } from 'immutable';
import { setSearchTerm, setSilentSearchTerm, setAddressSearchTerm, setSortBy, setScrollCache } from './actions';

export const defaultState = Map({
  searchTerm: '',
  silentSearchTerm: '',
  addressSearchTerm: '',
  sortBy: {
    field: '',
    order: '',
    page: ''
  },
  scrollCache: {}
});

export default function global(state = defaultState, action) {
  const newState = fromJS(state);

  switch (action.type) {
    case setSearchTerm.type:
      return newState.set('searchTerm', action.payload);
    case setAddressSearchTerm.type:
      return newState.set('addressSearchTerm', action.payload);
    case setSortBy.type:
      return newState.set('sortBy', action.payload);
    case setSilentSearchTerm.type:
      return newState.set('silentSearchTerm', action.payload);
    case setScrollCache.type:
      return newState.set('scrollCache', {
        ...newState.get('scrollCache'),
        [action.payload.key]: action.payload.value
      });

    default:
      return newState;
  }
}

export const searchTerm = state => state.global.get('searchTerm');
export const silentSearchTerm = state => state.global.get('silentSearchTerm');
export const addressSearchTerm = state => state.global.get('addressSearchTerm');
export const sortBy = state => state.global.get('sortBy');
export const getScrollCache = (state, page) => state.global.get('scrollCache')[page];
